export default "__VITE_ASSET__Cbchnj2o__"